<template>
  <div class="">
    <Navbar/>

    <div id="main">
      <div class="container">
        <div class="row align-items-center text-center">
          <div class="col-md-12 p-0" v-lazy-container="{selector:'img'}">
              <img data-src="/logo/search_demo_pic002-1.png"
              data-loading="/logo/search_demo_pic002-1.png"
              style="width:100%;max-height:495px;object-fit:cover;">
              <div id="centered">
                <h2>Featured Commercial Models</h2>
                <button type="button" class="btn btn-light" @click="redirect('/searchmodels')">
                  <i class="fas fa-search"></i> Search Commercial Models
                </button>
              </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div id="detail" style="min-height:200px; background: linear-gradient(#1b1b1b, #040607); color:#fff;">
            <div class="row">
              <div class="col-9">
                <h4>Idiom Models</h4>
              </div>
            </div>
            <div id="main_content_wrap" v-if="display">
              <div id="main_content" class="row" v-if="models.length">
                <div class="col-12" v-lazy-container="{selector:'img'}" v-for="(val,key) in models" :key="key">
                  <img class="image-fit" :data-src="idiom+val.primary_img" @load="onImgLoad" @click="previewModel(val)"/>
                  <div class="text-center">
                    <font color="white">{{ val.fname+" "+val.lname }}</font>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer/>
    </div>

    <ModalModels :model="model" :show="showModal" @close="showModal=false"/>

  </div>

</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import ModalModels from '@/components/ModalModels.vue'

export default {
  name: 'Models',
  components: { Navbar, Footer, ModalModels },
  data(){
    return {
      processing: false,
      full_search: false,
      models: [],
      model: {},
      display: true,
      showModal: false,
    }
  },
  created(){
    this.models = this.LocalStorage("_IdiomtalentModels",new Array());

    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted(){
    if(!this.models.length)this.get_models();
  },
  methods:{
    async get_models(){
      if(this.full_search || this.processing)return false;

      this.processing = true;
      var url = this.api+'models/get_models/'+this.secret;
      var data = new FormData();
      let ignore = this.models.map(e => e.id);
      if(ignore.length){
        data.set('ignore',JSON.stringify(ignore) );
      }
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
      .then((response)=>{
        if(response.data.error==0){
          response.data.data.forEach((e)=>{
            let findIndex = this.models.findIndex(x => x.id == e.id);
            if(findIndex==-1)this.models.push(e);
          });
          localStorage.setItem("_IdiomtalentModels",JSON.stringify(this.models));
        }else{
          this.full_search = true;
        }
      })
      .catch((error)=>{
        console.error(error);
      })
      .then(()=>{
        this.processing = false;
      })
    },
    previewModel(model){
      if(!model.primary_img){
        return false;
      }else{
        if(model.count_img>1 && !model.images){
          this.get_all_images(model);
        }else{
          this.openModal(model);
        }
      }
    },
    openModal(model){
      this.model = model;
      this.showModal = true;
    },
    async get_all_images(model){
      model.images = [];

      var url = this.api+'models/get_all_images/'+this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      data.set('models_id', model.id);
      await this.Axios.post(url, data)
      .then((response)=>{
        if(response.data.error==0){
          response.data.data.forEach((e) => {
            model.images.push(e)
          });
        }
        this.openModal(model);
      })
      .catch((error)=>{
        console.error(error);
      })
    },
  },
  watch:{
    showModal(val,old){
      if(old && !val)this.model = {};
    }
  }
}
</script>

<style scoped>
  /* #main { background-color:#aa4d8e !important; } */
  #main { background-color:#894073!important; }
  #centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff !important;
    width: 100%;
  }
  #detail{
    padding: 50px;
    width:100% !important;
  }
  #detail small{ font-size:16px; }
  .image-fit{
    /* height: 100%; */
    height: 225px !important;
    width: 100%;
    object-fit: cover;
    cursor: pointer;
  }
  @media (max-width: 600px) {
    #centered button{
      padding: .25rem .5rem;
      font-size: .875rem;
      line-height: 1.5;
      border-radius: .2rem;
    }
    #centered h2{ font-size:18px; }
    #detail h4{ font-size:18px; }
    #detail small{ font-size:14px; }
    #detail{ padding: 25px; }
    #modal_models .card-content .media-content .title{
      font-size: 18px !important;
    }
    #modal_models .card-content .media-content .subtitle{
      font-size: 14px !important;
    }
    @media (orientation: landscape) {
      .image-fit{ width: 50% !important; }
    }
  }

  #modal_models .card .content p{ margin-bottom: 1px; }
  #modal_models .card .content span{ cursor: pointer; }
</style>
